module.exports = __webpack_public_path__ + "assets/retina_Chord3Detailed.22a7c2455921e04e91bfcbc80c0b6630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Chord3Detailed.png
// module id = 633
// module chunks = 0